import React from "react";
import Header from "../components/Header";
import CartListContainer from "../components/CartListContainer";

const CartPage = () => {
  return (
    <>
      <Header />

      <main className="py-16">
        <div className="container 2xl:px-8 px-2 mx-auto">
          <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
          <CartListContainer />
        </div>
      </main>
    </>
  );
};

export default CartPage;
